export const dummyHabits = require("./sidebar_habits.json");
export const dummyTips = require("./sidebar_tips.json");
